import { apiClient } from './client';
import type { ApiResponse, PagedResult } from '@/types/api.types';
import type {
  ApBillDto,
  ApBillListDto,
  ApBillFilterDto,
  CreateApBillRequest,
  UpdateApBillRequest,
} from '@/types/apBill.types';

export const apBillApi = {
  /** GET /api/v1/ap-bills — paginated list */
  getList: (filter?: ApBillFilterDto) =>
    apiClient.get<ApiResponse<PagedResult<ApBillListDto>>>('/ap-bills', { params: filter }),

  /** GET /api/v1/ap-bills/{id} — full bill with lines */
  getById: (id: string) =>
    apiClient.get<ApiResponse<ApBillDto>>(`/ap-bills/${id}`),

  /** POST /api/v1/ap-bills — create new bill (Draft) */
  create: (data: CreateApBillRequest) =>
    apiClient.post<ApiResponse<{ id: string }>>('/ap-bills', data),

  /** PUT /api/v1/ap-bills/{id} — update draft bill */
  update: (id: string, data: UpdateApBillRequest) =>
    apiClient.put<ApiResponse<object>>(`/ap-bills/${id}`, data),

  /** POST /api/v1/ap-bills/{id}/submit — submit for approval */
  submit: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/ap-bills/${id}/submit`),

  /** POST /api/v1/ap-bills/{id}/approve — approve the bill */
  approve: (id: string, remarks?: string) =>
    apiClient.post<ApiResponse<object>>(`/ap-bills/${id}/approve`, { remarks }),

  /** POST /api/v1/ap-bills/{id}/reject — reject with reason */
  reject: (id: string, reason: string) =>
    apiClient.post<ApiResponse<object>>(`/ap-bills/${id}/reject`, { reason }),

  /** POST /api/v1/ap-bills/{id}/post — post to general ledger */
  post: (id: string) =>
    apiClient.post<ApiResponse<object>>(`/ap-bills/${id}/post`),

  /** POST /api/v1/ap-bills/{id}/reverse — create debit note reversal */
  reverse: (id: string, reversalDate: string, reversalPostingDate: string, narration?: string) =>
    apiClient.post<ApiResponse<{ id: string }>>(`/ap-bills/${id}/reverse`, {
      reversalDate,
      reversalPostingDate,
      narration,
    }),

  /** POST /api/v1/ap-bills/{id}/cancel — cancel the bill */
  cancel: (id: string, reason?: string) =>
    apiClient.post<ApiResponse<object>>(`/ap-bills/${id}/cancel`, { reason }),

  /** DELETE /api/v1/ap-bills/{id} — soft-delete (draft only) */
  delete: (id: string) =>
    apiClient.delete<ApiResponse<object>>(`/ap-bills/${id}`),
};
